var lib_core = require("lib-core");
var PosAngleData = require("./posAngleData.js");
var cio_config = require("cio-config");

var PosAngleFlipData = {
    addPosAngleFlip: function (pos, angle, flip) {
        this.addPosAngle(pos, angle);

        this.xflip = this.value("xflip", true, cio_config.types.int.validator);

        if(flip != undefined) this.xflip(flip);
    }
};
lib_core.extend(PosAngleFlipData, PosAngleData);

PosAngleFlipData.flip = function(flipline) {
    this.rotate(180 * flipline.dir.x);
    this.xflip(this.xflip() * -1);
};

PosAngleFlipData.getTransform = function() {
    var transform = PosAngleData.getTransform.call(this);
    transform.flip = this.xflip() == -1;
    return transform;
};

module.exports = PosAngleFlipData;
